import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    currentRouteKey: '',
    selectedDashboard: 'Plataforma',
    oraculoIsOpen: false,
}

export const commonSlice = createSlice({
    name: 'base/common',
    initialState,
    reducers: {
        setCurrentRouteKey: (state, action) => {
            state.currentRouteKey = action.payload 
        },
        setSelectedDashboard: (state, action) => {
            state.selectedDashboard = action.payload
        },
        setOraculoIsOpen: (state, action) => {
            state.oraculoIsOpen = action.payload
        }
    },
})

export const { setCurrentRouteKey, setSelectedDashboard, setOraculoIsOpen } = commonSlice.actions

export default commonSlice.reducer
